import { useEffect, useState } from 'react';

const DEFAULT_DURATION = 60;

const formatTimer = (seconds: number) => {
  const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
  const remainingSeconds = String(seconds % 60).padStart(2, '0');

  return `${minutes}:${remainingSeconds}`;
};

export function useOtpTimer(duration: number = DEFAULT_DURATION) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!active || timeLeft === 0) {
      if (timeLeft === 0) setActive(false);
      return;
    }

    const timer = window.setTimeout(() => {
      setTimeLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => window.clearTimeout(timer);
  }, [active, timeLeft]);

  const start = (nextDuration = duration) => {
    if (nextDuration > 1000) {
      nextDuration = Math.ceil(nextDuration / 1000);
    }

    setTimeLeft(nextDuration);
    setActive(true);
  };

  const reset = () => {
    setTimeLeft(duration);
    setActive(false);
  };

  return {
    timeLeft,
    formattedTimeLeft: formatTimer(timeLeft),
    active,
    start,
    reset,
    formatTimer,
  };
}
